"use client";

import { cva } from "cva";
import { cn } from "#ui-atoms/lib/utils";
import { BaseCheckbox, type BaseCheckboxProps } from "./checkbox";

// TODO: remove all the generic colors, that was for testing since our tenant hexes are not setup yet
const conEdisonCheckboxVariants = cva({
  // base: "data-[state=checked]:bg-tenant-con-edison-website-primary data-[state=checked]:text-tenant-con-edison-primary-white",
  base: "bg-red-400",
  variants: {
    tenantVariant: {
      "oru-reco": null,
    },
  },
  compoundVariants: [
    {
      tenantVariant: ["oru-reco"],
      // className:
      //   "data-[state=checked]:bg-tenant-oru-website-primary data-[state=checked]:text-tenant-oru-primary-white",
      className: "bg-blue-400",
    },
  ],
});

export default function ConEdisonCheckbox({
  className,
  tenant,
  ...props
}: BaseCheckboxProps) {
  const tenantVariant =
    tenant?.variantId === "oru-reco" ? "oru-reco" : undefined;

  return (
    <BaseCheckbox
      {...props}
      className={cn(
        conEdisonCheckboxVariants({ ...(tenantVariant && { tenantVariant }) }),
        className,
      )}
    />
  );
}
